var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-filters product-filters__desktop" },
    [
      _c("div", { staticClass: "product_list__filters-wrapper" }, [
        _c("form", [
          _vm.productFiltersObject
            ? _c("div", { staticClass: "product_list__filters" }, [
                _vm.productFiltersObject.materials
                  ? _c("div", [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown",
                            class:
                              _vm.dropDownOpen === "materials"
                                ? "is-active"
                                : "",
                          },
                          [
                            _c("div", { staticClass: "dropdown-trigger" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "button is-primary",
                                  attrs: {
                                    "aria-haspopup": "true",
                                    "aria-controls": "dropdown-menu",
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleDropDown("materials")
                                    },
                                  },
                                },
                                [
                                  _vm.languageStrings.all_materials
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.languageStrings.all_materials
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(0),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                attrs: { id: "dropdown-menu", role: "menu" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "dropdown-content" },
                                  [
                                    _c(
                                      "div",
                                      _vm._l(
                                        _vm.productFiltersObject.materials,
                                        function (materialItem, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "dropdown-item",
                                            },
                                            [
                                              _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.tagFilters,
                                                      expression: "tagFilters",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id:
                                                      "material" +
                                                      materialItem.slug,
                                                    name:
                                                      "material" +
                                                      materialItem.slug,
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    value: materialItem.slug,
                                                    checked: Array.isArray(
                                                      _vm.tagFilters
                                                    )
                                                      ? _vm._i(
                                                          _vm.tagFilters,
                                                          materialItem.slug
                                                        ) > -1
                                                      : _vm.tagFilters,
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$a =
                                                            _vm.tagFilters,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v =
                                                              materialItem.slug,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.tagFilters =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.tagFilters =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.tagFilters = $$c
                                                        }
                                                      },
                                                      _vm.filterEvent,
                                                    ],
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for:
                                                        "material" +
                                                        materialItem.slug,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(materialItem.name)
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _vm.tagFilters.length > 0 &&
                                    _vm.languageStrings.clear_filters
                                      ? [
                                          _c("hr", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-item is-active",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-small",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      ;(_vm.tagFilters = []),
                                                        _vm.filterEvent()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.languageStrings
                                                          .clear_filters
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.productFiltersObject.tags
                  ? _c("div", [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown",
                            class:
                              _vm.dropDownOpen === "tags" ? "is-active" : "",
                          },
                          [
                            _c("div", { staticClass: "dropdown-trigger" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "button is-primary",
                                  attrs: {
                                    "aria-haspopup": "true",
                                    "aria-controls": "dropdown-menu",
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleDropDown("tags")
                                    },
                                  },
                                },
                                [
                                  _vm.languageStrings.all_shapes
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.languageStrings.all_shapes)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(1),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                attrs: { id: "dropdown-menu", role: "menu" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "dropdown-content" },
                                  [
                                    _c(
                                      "div",
                                      _vm._l(
                                        _vm.productFiltersObject.tags,
                                        function (tagItem, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "dropdown-item",
                                            },
                                            [
                                              _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.tagFilters,
                                                      expression: "tagFilters",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "tags" + tagItem.slug,
                                                    name: "tags" + tagItem.slug,
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    value: tagItem.slug,
                                                    checked: Array.isArray(
                                                      _vm.tagFilters
                                                    )
                                                      ? _vm._i(
                                                          _vm.tagFilters,
                                                          tagItem.slug
                                                        ) > -1
                                                      : _vm.tagFilters,
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$a =
                                                            _vm.tagFilters,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v =
                                                              tagItem.slug,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.tagFilters =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.tagFilters =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.tagFilters = $$c
                                                        }
                                                      },
                                                      _vm.filterEvent,
                                                    ],
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for:
                                                        "tags" + tagItem.slug,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(tagItem.name))]
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _vm.tagFilters.length > 0 &&
                                    _vm.languageStrings.clear_filters
                                      ? [
                                          _c("hr", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-item is-active",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button is-small",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      ;(_vm.tagFilters = []),
                                                        _vm.filterEvent()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.languageStrings
                                                          .clear_filters
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.productFiltersObject.interfaces
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "dropdown",
                          class:
                            _vm.dropDownOpen === "interface" ? "is-active" : "",
                        },
                        [
                          _c("div", { staticClass: "dropdown-trigger" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary",
                                attrs: {
                                  "aria-haspopup": "true",
                                  "aria-controls": "dropdown-menu",
                                  type: "button",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.toggleDropDown("interface")
                                  },
                                },
                              },
                              [
                                _vm.languageStrings.all_interfaces
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.languageStrings.all_interfaces
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._m(2),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu",
                              attrs: { id: "dropdown-menu", role: "menu" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "dropdown-content" },
                                [
                                  _c(
                                    "div",
                                    _vm._l(
                                      _vm.productFiltersObject.interfaces,
                                      function (interfaceItem, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "dropdown-item",
                                          },
                                          [
                                            _c("div", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.tagFilters,
                                                    expression: "tagFilters",
                                                  },
                                                ],
                                                attrs: {
                                                  id:
                                                    "interface" +
                                                    interfaceItem.slug,
                                                  name:
                                                    "interface" +
                                                    interfaceItem.slug,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  value: interfaceItem.slug,
                                                  checked: Array.isArray(
                                                    _vm.tagFilters
                                                  )
                                                    ? _vm._i(
                                                        _vm.tagFilters,
                                                        interfaceItem.slug
                                                      ) > -1
                                                    : _vm.tagFilters,
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$a = _vm.tagFilters,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v =
                                                            interfaceItem.slug,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.tagFilters =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.tagFilters =
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                        }
                                                      } else {
                                                        _vm.tagFilters = $$c
                                                      }
                                                    },
                                                    _vm.filterEvent,
                                                  ],
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "interface" +
                                                      interfaceItem.slug,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(interfaceItem.name)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm.tagFilters.length > 0 &&
                                  _vm.languageStrings.clear_filters
                                    ? [
                                        _c("hr", {
                                          staticClass: "dropdown-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-item is-active",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "button is-small",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    ;(_vm.tagFilters = []),
                                                      _vm.filterEvent()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.languageStrings
                                                        .clear_filters
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", {
        staticClass: "fas fa-angle-down",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", {
        staticClass: "fas fa-angle-down",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", {
        staticClass: "fas fa-angle-down",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }